'use strict'

import d3 from 'd3'
import bodymovin from 'bodymovin'
import {bootstrap} from '../bootstrap/bootstrap'
import {GlyphChart, ClassedGlyphChart} from '../glyphs/charts'
import {Glyph, YellowHexagonGlyph, ClassedGlyph} from '../glyphs/glyphs'
import ComponentLoader from '../component-loader/index'
import {attachEvents} from './sliderControls'
import {getAnimationEndpoint} from './networking'
import {stepBodyMovinAnimations, stepGylphAnimationCharts} from './stepAnimations'

const animationsEndpoint = '/cmsapi/v1/animations/'
const loaderAccurate = new ComponentLoader()
const loaderContext = new ComponentLoader()
const loaderAccurateContainer = document.querySelector('.slider-content-animation[data-name="accurate"] .component-loader')
const loaderContextContainer = document.querySelector('.slider-content-animation[data-name="context"] .component-loader')
const sliderAccurate = document.querySelector('.slider-content-animation[data-name="accurate"]')
const sliderContext = document.querySelector('.slider-content-animation[data-name="context"]')
const sliderGathering = document.querySelector('.slider-content-animation[data-name="gathering"]')
const svgContextContainer = document.querySelector('.svg--context')
const svgAccurateDataContainer = document.querySelector('.svg--accurate-data')
const classWeights = [
  {class: 'glyph', weight: 0.2},
  {class: 'glyph glyph--accent', weight: 0.4},
  {class: 'glyph glyph--red', weight: 0.6},
  {class: 'glyph glyph--blue', weight: 0.8},
  {class: 'glyph glyph--yellow', weight: 0.9}
]
const animationSegments = {
  accurate: [[0, 240], [270, 660]],
  context: [[840, 1060], [1060, 1261]]
}
const glyphAnimationSegments = [
  {
    class: 'glyph-chart--customers',
    configuration: [GlyphChart, d3, YellowHexagonGlyph, 0.21, 4, -10]
  },
  {
    class: 'glyph-chart--scale',
    configuration: [GlyphChart, d3, Glyph, 0.21, 30, -4, 750]
  },
  {
    class: 'glyph-chart--target',
    configuration: [ClassedGlyphChart, d3, ClassedGlyph, classWeights, 0.21, 30, -4, 300]
  }
]

loaderAccurate.selectLoader(loaderAccurateContainer)
loaderContext.selectLoader(loaderContextContainer)
bootstrap(sliderGathering, attachEvents, stepGylphAnimationCharts, glyphAnimationSegments)
bootstrap(svgAccurateDataContainer, svgAccurateDataWrapper => {
  getAnimationEndpoint(`${animationsEndpoint}hiw-accurate/`, animationEndpoint => {
    loaderAccurate.hideLoader(() => {
      const bmAccurateAnimation = bodymovin.loadAnimation({
        container: svgAccurateDataWrapper,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: animationEndpoint.instructions
      })
      bootstrap(sliderAccurate, attachEvents, stepBodyMovinAnimations, 'accurate',
                bmAccurateAnimation, animationSegments)
    })
  })
})

bootstrap(svgContextContainer, svgContextContainer => {
  getAnimationEndpoint(`${animationsEndpoint}hiw-context/`, animationEndpoint => {
    loaderContext.hideLoader(() => {
      const bmContextAnimation = bodymovin.loadAnimation({
        container: svgContextContainer,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: animationEndpoint.instructions
      })
      bootstrap(sliderContext, attachEvents, stepBodyMovinAnimations, 'context',
                bmContextAnimation, animationSegments)
    })
  })
})
